import React from "react";

import PrivacyPolicyLayout from "./PrivacyPolicyLayout";

const RefundPolicy = () => {
  return (
    <PrivacyPolicyLayout>
      <h1>REFUND POLICY</h1>

      <p>
        Our policy lasts 14 days. If 14 days have gone by since your purchase,
        unfortunately, we can’t offer you a refund or exchange. Several types of
        goods and services are exempt from being returned. A refund for a
        particular tournament is not allowed if you have participated in any
        round of that tournament. To be eligible for a refund, you should
        specify the reason for the refund. To complete your return, please write
        to us at <a href="mailto:contact@maidaan.app">contact@maidaan.app</a>.
      </p>
      <br />
      <h2>Refunds (if applicable)</h2>
      <p>
        Once your refund request is received, your request will be verified. If
        approved, then your refund will be processed, and a credit will
        automatically be applied within 14 days.
      </p>
      <br />
      <h2>Late or missing refunds (if applicable)</h2>
      <p>
        If you haven’t received a refund after confirmation of the refund credit
        from us, please first check your bank account again. Then contact your
        credit card company, it may take some time before your refund is
        officially posted. Next, contact your bank. There is often some
        processing time before a refund is posted. If you’ve done all of this
        and you still have not received your refund yet, please contact us at{" "}
        <a href="mailto:contact@maidaan.app">contact@maidaan.app</a>.
      </p>
      <br />
      <h2>Refund process</h2>
      <p>
        Please write to{" "}
        <a href="mailto:contact@maidaan.app">contact@maidaan.app</a> asking for
        a refund.
      </p>
    </PrivacyPolicyLayout>
  );
};

export default RefundPolicy;
